import styled from 'styled-components';

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const SlotExtraForm = styled.div`
`;

export const ConcludeButtonContainer = styled.div`
  display: flex;
  align-items: center;  
  justify-content: flex-end;

  width: 100%;

  margin-bottom: 26px;
  margin-right: 26px;
  margin-top: 26px;

  button + button{
    margin-left: 6px;
  }
`;
